var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLogo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 937.31 365.32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}.cls-5{fill:url(#linear-gradient-5);}.cls-6{fill:url(#linear-gradient-6);}.cls-7{fill:url(#linear-gradient-7);}.cls-8{fill:url(#linear-gradient-8);}.cls-9{fill:url(#linear-gradient-9);}.cls-10{fill:url(#linear-gradient-10);}.cls-11{fill:url(#linear-gradient-11);}.cls-12{fill:url(#linear-gradient-12);}.cls-13{fill:url(#linear-gradient-13);}.cls-14{fill:url(#linear-gradient-14);}.cls-15{fill:url(#linear-gradient-15);}.cls-16{fill:url(#linear-gradient-16);}.cls-17{fill:url(#linear-gradient-17);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 851.56,
    y1: 221.34,
    x2: 851.57,
    y2: 221.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1f96ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2a4dff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 783.33,
    y1: 293.34,
    x2: 851.57,
    y2: 293.34,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 192.72,
    y1: 276.61,
    x2: 280.52,
    y2: 188.81,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 262.55,
    y1: 305.07,
    x2: 374.12,
    y2: 193.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 387.96,
    y1: 286.79,
    x2: 467.47,
    y2: 207.28,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 859.06,
    y1: 286.5,
    x2: 938.44,
    y2: 207.12,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 490.59,
    y1: 182.56,
    x2: 851.58,
    y2: 182.56,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 521.01,
    y1: 213,
    x2: 673.15,
    y2: 213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2a4dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1f96ff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 755.3,
    y1: 310.79,
    x2: 681.53,
    y2: 183,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 490.59,
    y1: 106.49,
    x2: 711.81,
    y2: 106.49,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 0.06,
    y1: 44.22,
    x2: 355.03,
    y2: 44.22,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 191.39,
    y1: 44.22,
    x2: 355.03,
    y2: 44.22,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 0,
    y1: 44.22,
    x2: 171.08,
    y2: 44.22,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 143.48,
    y1: 221.7,
    x2: 211.72,
    y2: 221.7,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 143.48,
    y1: 279.58,
    x2: 211.72,
    y2: 279.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2a4dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1f96ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 143.47,
    y1: 126.02,
    x2: 158.76,
    y2: 126.02,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 282.8,
    y1: 365.09,
    x2: 282.97,
    y2: 365.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "blue"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b1464"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M851.57,221.33v0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M811.17,302a182.09,182.09,0,0,0,40.4-80.68v58.07c0,15.75-10.12,45-17.85,55.34-13.15,17.56-30.93,27.08-50.39,30.55V328.13A183.45,183.45,0,0,0,811.17,302Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M220.67,181.24V160.85h31.89v20.39Zm0,123.32V189.11h31.89V304.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M292.73,204.45h.4c3.23-10.7,10.5-16.75,22.21-16.75,11.5,0,18.57,5.65,20.79,16.75h.4c1.82-10.3,10.7-16.75,22-16.75,16,0,21,10.29,21,24.42v92.44H348.84V224.43c0-5-.4-10.49-6.46-10.49s-6.25,5.45-6.25,10.49v80.13H305.45V224.43c0-5-.41-10.49-6.46-10.49s-6.26,5.45-6.26,10.49v80.13H262.05V189.11h30.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M420.7,250.47v23.41c0,6.87,2.42,11.1,6.66,11.1,5.05,0,6.66-4.23,6.66-11.1V259h31.89V275.9c0,21.8-16.14,30.08-38.55,30.08-20.38,0-38.55-9.29-38.55-30.68V220.19c0-20.79,13.73-32.49,38.55-32.49,20.39,0,38.55,7.67,38.55,32.49v30.28ZM434,231.29V215.55c0-4.44-2.22-6.86-6.66-6.86s-6.66,2.42-6.66,6.86v15.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M937.31,275.3c0,21.39-18.17,30.68-38.56,30.68s-38.55-9.29-38.55-30.68V220.19c0-20.79,13.73-32.49,38.55-32.49s38.56,11.7,38.56,32.49Zm-45.22,1.61c0,4.24,1.62,8.07,6.66,8.07s6.66-3.83,6.66-8.07V216.76c0-4.24-1.61-8.07-6.66-8.07s-6.66,3.83-6.66,8.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M845.58,209.81a60.79,60.79,0,0,0-50.7-27.25h0c0,3.15-.12,6.28-.35,9.37-.08,1-.17,2.06-.28,3.08-.09.85-.18,1.71-.29,2.57s-.24,1.76-.36,2.64c-.08.61-.18,1.2-.28,1.8a120.69,120.69,0,0,1-12.17,36.74c-.13.26-.27.5-.4.76-.43.81-.86,1.61-1.33,2.42-.69,1.25-1.41,2.51-2.16,3.73-.5.83-1,1.66-1.55,2.49-.86,1.35-1.74,2.67-2.66,4-.45.64-.9,1.28-1.37,1.91s-.93,1.28-1.41,1.91c-.72,1-1.45,1.89-2.19,2.81a124.19,124.19,0,0,1-14.77,15.39c-.89.79-1.81,1.55-2.72,2.31-.75.61-1.51,1.23-2.27,1.82s-1.39,1.09-2.11,1.62h0l-.21.16c-.72.55-1.45,1.07-2.18,1.59-.46.33-.92.66-1.4,1-1,.7-2,1.37-3,2a111.92,111.92,0,0,1-9.78,5.71c-2.86,1.52-5.8,2.92-8.79,4.17l-.46.2c-.57.25-1.13.48-1.7.7l-2.54,1c-1,.39-2,.74-3,1.08s-2.13.73-3.2,1.07c-.63.21-1.27.41-1.9.59s-1.26.39-1.91.56c-1.81.51-3.63,1-5.45,1.4-1,.23-2,.44-3,.64q-4.12.85-8.27,1.4c-.76.1-1.53.2-2.28.28l-2.3.25q-5.77.54-11.68.54a119.63,119.63,0,0,1-12.46-.63c-.65-.06-1.3-.13-2-.22-.91-.1-1.81-.22-2.71-.35-.63-.07-1.26-.17-1.9-.28-1.26-.2-2.53-.4-3.77-.66-1-.18-2-.39-3-.59l-.3-.08-.93-.21c-.74-.15-1.47-.32-2.2-.51-.93-.22-1.84-.46-2.74-.71-.46-.11-.93-.25-1.39-.38s-1.19-.34-1.79-.52-1-.3-1.51-.47c-.85-.25-1.69-.53-2.52-.82l-2.71-.95c-1.14-.43-2.27-.86-3.39-1.32l-.36-.14c-.91-.37-1.84-.76-2.74-1.15-1.76-.75-3.51-1.56-5.23-2.41s-3.42-1.73-5.11-2.65l-1.9-1.07c-.77-.44-1.52-.88-2.28-1.34-1-.63-2.11-1.29-3.17-2s-2.18-1.45-3.26-2.19c-.74-.51-1.47-1-2.19-1.55-.25-.17-.48-.36-.72-.54-.68-.49-1.35-1-2-1.51a.73.73,0,0,1-.18-.14c-.81-.61-1.6-1.23-2.38-1.88a2.68,2.68,0,0,1-.26-.23c-.72-.57-1.43-1.16-2.12-1.76-.17-.14-.33-.28-.5-.44-.67-.56-1.33-1.15-2-1.74l-.5-.45c-.59-.53-1.16-1.06-1.72-1.61-.23-.21-.46-.43-.69-.67-.5-.47-1-1-1.5-1.46s-.74-.74-1.11-1.13c-.24-.23-.46-.46-.67-.7-.52-.53-1-1.08-1.55-1.64-.91-1-1.8-2-2.66-3-.46-.53-.92-1.06-1.37-1.6l-.18-.21a2.65,2.65,0,0,1-.17-.22c-.42-.5-.82-1-1.23-1.52-.82-1-1.65-2.06-2.45-3.13-.63-.83-1.23-1.66-1.83-2.5l-.07-.09c-.53-.77-1.07-1.54-1.59-2.32-.36-.52-.71-1.06-1.06-1.59-.21-.28-.38-.57-.56-.85a1.39,1.39,0,0,1-.18-.31l-.33-.52c-.26-.4-.5-.8-.76-1.22A121.72,121.72,0,0,1,670,60.89c1,0,2.09,0,3.14,0A60.67,60.67,0,0,0,711.81,47a60.75,60.75,0,0,0,21.35-36.9A182.55,182.55,0,0,0,490.64,178.63c0,.65,0,1.31,0,2s0,1.31,0,2c0,99.5,79.62,180.43,178.62,182.51l2,0c.66,0,1.32,0,2,0A182.71,182.71,0,0,0,851.58,221.36,59.68,59.68,0,0,0,845.58,209.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M673.15,304.26v60.86c-.66,0-1.32,0-2,0l-2,0A152.24,152.24,0,0,1,524.06,182.56q.8-3.94,1.81-7.82c.24-1,.5-1.94.78-2.9s.61-2.15.94-3.21c.06-.24.14-.48.21-.73.3-1,.6-1.91.92-2.84a3.71,3.71,0,0,1,.16-.47c.32-1,.67-2,1-3,0-.14.1-.28.15-.41.4-1.12.82-2.24,1.25-3.35l0-.11c.78-2,1.59-4,2.45-5.91.2-.45.39-.89.6-1.32.35-.8.72-1.6,1.1-2.39.13-.31.28-.6.42-.89.44-.92.88-1.83,1.34-2.73.55-1.08,1.11-2.15,1.68-3.22s1.16-2.13,1.75-3.18c1.14-2,2.32-4,3.53-5.93a2.61,2.61,0,0,1,.2-.3c.64-1,1.3-2,2-3s1.31-2,2-2.92c0-.09.11-.16.17-.25.56-.79,1.14-1.58,1.71-2.37a7.26,7.26,0,0,1,.46-.63c.66-.89,1.31-1.77,2-2.64s1.48-1.9,2.23-2.83,1.53-1.86,2.31-2.77a.15.15,0,0,1,0-.06c.77-.9,1.55-1.79,2.33-2.67s1.62-1.78,2.43-2.65,1.66-1.75,2.5-2.61,1.6-1.62,2.42-2.41c.11-.11.21-.22.32-.31.69-.67,1.4-1.34,2.11-2,.15-.15.31-.29.45-.41.61-.58,1.23-1.14,1.85-1.68,2.11-1.9,4.26-3.73,6.47-5.49.78-.62,1.57-1.24,2.36-1.84l.87-.67c.65-.5,1.29-1,2-1.45l.51-.38c.89-.64,1.79-1.29,2.7-1.92,0,0,0,0,0,0,.78-.55,1.56-1.08,2.35-1.61l1-.65c.8-.54,1.61-1.06,2.44-1.56,2.17-1.38,4.36-2.68,6.6-3.92.92-.52,1.85-1,2.77-1.52l1-.54,1.87-1,1.75-.86c.85-.43,1.72-.84,2.58-1.23s1.84-.85,2.76-1.27l.21-.08c.89-.4,1.79-.78,2.69-1.15q3.87-1.62,7.85-3c1-.34,1.92-.67,2.9-1,.21-.08.41-.15.62-.21q1.44-.48,2.88-.9a4.13,4.13,0,0,1,.5-.15c1.1-.34,2.19-.65,3.29-.94s2.08-.58,3.13-.83l.68-.17c1.13-.28,2.26-.55,3.41-.81,2.42-.53,4.85-1,7.31-1.43a.46.46,0,0,1,.21,0c1.09-.19,2.2-.36,3.29-.53l.83-.11c1-.15,1.91-.27,2.87-.39l.7-.08c1-.13,2.09-.24,3.14-.34l.5,0c1.14-.11,2.3-.2,3.45-.28h.15c.83-.06,1.66-.12,2.5-.16l1.78-.08c1.12,0,2.24-.09,3.38-.11A121.72,121.72,0,0,0,569.34,246.11c.26.42.5.82.76,1.22l.33.52.18.31c.18.29.36.57.56.85.35.53.7,1.07,1.06,1.59.52.78,1.06,1.55,1.59,2.32l.07.09a122.25,122.25,0,0,0,38.67,35.13l1.9,1.07q2.53,1.38,5.11,2.65c1.72.85,3.47,1.66,5.23,2.41a118.59,118.59,0,0,0,25.56,7.85c1.24.26,2.51.46,3.77.66.64.11,1.27.21,1.9.28.9.13,1.8.25,2.71.35.65.09,1.3.16,2,.22A119.63,119.63,0,0,0,673.15,304.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M845.58,209.81a151.62,151.62,0,0,1-70,89.28c-.74.43-1.47.84-2.21,1.25a152.08,152.08,0,0,1-202.74-52.18c-.18-.27-.35-.55-.51-.83l.33.52c.24.39.5.77.74,1.16s.7,1.07,1.06,1.59c.52.78,1.06,1.56,1.59,2.32l.07.09a121,121,0,0,0,38.67,35.13l1.9,1.07q2.53,1.38,5.11,2.65t5.23,2.41a123.24,123.24,0,0,0,25.56,7.85c1.26.24,2.52.46,3.77.66l1.9.28c.9.13,1.8.25,2.71.35.65.09,1.3.16,2,.22a117.63,117.63,0,0,0,12.46.66,121.35,121.35,0,0,0,24.53-2.5c1-.19,2-.41,3-.64,1.82-.43,3.64-.89,5.45-1.4l1.91-.56c.63-.18,1.27-.38,1.9-.59,1.07-.33,2.14-.7,3.2-1.06s1.88-.67,2.81-1l.19-.07A122.07,122.07,0,0,0,734,288c1.82-1.05,3.62-2.15,5.38-3.28,1-.65,2-1.32,3-2,.48-.32.94-.65,1.4-1,.73-.52,1.46-1,2.18-1.59l.21-.15h0c.72-.53,1.41-1.07,2.11-1.62s1.53-1.2,2.27-1.82a120.58,120.58,0,0,0,25.12-28.32c.54-.83,1.05-1.66,1.55-2.49.75-1.22,1.47-2.48,2.16-3.73.47-.81.9-1.61,1.33-2.42.13-.26.27-.5.4-.76A122.51,122.51,0,0,0,793.29,202c.1-.6.2-1.19.28-1.8.12-.88.25-1.77.36-2.64s.2-1.72.29-2.57c.11-1,.2-2.06.28-3.08q.38-4.68.38-9.37A60.79,60.79,0,0,1,845.58,209.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M642.72,30.43A151.3,151.3,0,0,1,711.81,47a60.67,60.67,0,0,1-38.66,13.86c-1,0-2.1,0-3.14,0s-2.26.06-3.38.11l-1.78.08c-.84,0-1.67.1-2.5.16h-.15c-1.15.08-2.31.17-3.45.28l-.5,0c-1,.1-2.11.21-3.14.34l-.7.08c-1,.12-1.92.24-2.87.39l-.83.11c-1.1.17-2.2.34-3.29.53a.46.46,0,0,0-.21,0c-2.46.41-4.89.89-7.31,1.43-1.15.26-2.28.53-3.41.81l-.68.17c-1,.25-2.1.53-3.13.83s-2.2.6-3.29.94a4.13,4.13,0,0,0-.5.15q-1.46.42-2.88.9c-.21.06-.41.13-.62.21-1,.31-1.94.64-2.9,1q-4,1.41-7.85,3c-.9.37-1.8.75-2.69,1.15l-.21.08c-.92.42-1.84.83-2.76,1.27s-1.73.8-2.58,1.23l-1.75.86-1.87,1-1,.54c-.93.5-1.86,1-2.77,1.52-2.24,1.24-4.43,2.54-6.6,3.92-.81.5-1.64,1-2.44,1.56l-1,.65c-.79.53-1.57,1-2.35,1.61,0,0,0,0,0,0q-1.37.94-2.7,1.92l-.51.38c-.66.48-1.3,1-2,1.45l-.87.67c-.79.6-1.58,1.22-2.36,1.84-2.21,1.76-4.36,3.59-6.47,5.49-.62.53-1.24,1.09-1.85,1.68-.14.12-.3.26-.45.41-.71.66-1.42,1.33-2.11,2-.11.09-.21.2-.32.31-.82.78-1.63,1.6-2.42,2.41s-1.68,1.73-2.5,2.61-1.63,1.75-2.43,2.65-1.56,1.77-2.33,2.67a.15.15,0,0,0,0,.06c-.78.91-1.56,1.84-2.31,2.77s-1.5,1.88-2.23,2.83-1.36,1.75-2,2.64a7.26,7.26,0,0,0-.46.63c-.59.78-1.15,1.57-1.71,2.37-.06.09-.12.16-.17.25-.68,1-1.35,1.93-2,2.92s-1.33,2-2,3a2.61,2.61,0,0,0-.2.3c-1.23,2-2.41,3.92-3.53,5.93-.61,1.05-1.19,2.1-1.75,3.18s-1.14,2.14-1.68,3.22c-.46.9-.91,1.81-1.34,2.73-.14.29-.29.58-.42.89-.38.79-.76,1.59-1.1,2.39-.21.43-.4.87-.6,1.32-.86,1.94-1.67,3.92-2.45,5.91l0,.11c-.44,1.11-.85,2.23-1.25,3.35,0,.13-.11.27-.15.41-.36,1-.71,2-1,3a3.71,3.71,0,0,0-.16.47c-.32.93-.62,1.9-.92,2.84-.07.25-.15.49-.21.73-.33,1.06-.65,2.13-.94,3.21s-.54,1.93-.78,2.9q-1,3.87-1.81,7.82H490.59c0-.66,0-1.32,0-2s0-1.31,0-2A152.12,152.12,0,0,1,621.35,31.92,153.7,153.7,0,0,1,642.72,30.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M355,10.09c-6.87,19.52-25.83,37.38-60.89,50.54-19,7.16-70.35,16.37-102.75,17.71H.06C7,58.88,25.92,41.1,60.89,28c20.57-7.73,78.83-17.87,110.19-17.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M355,10.09a68.17,68.17,0,0,1-24.88,52.7,68,68,0,0,1-43.36,15.55h-95.4C223.79,77,275.1,67.79,294.14,60.63,329.2,47.47,348.16,29.61,355,10.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M171.08,10.09C139.72,10.09,81.46,20.23,60.89,28,25.92,41.1,7,58.88.06,78.34H0A68.25,68.25,0,0,1,68.25,10.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M211.72,78.34V194c0,31.37-10.13,89.62-17.87,110.2-13.13,35-30.91,53.91-50.37,60.84V173.7c1.19-28.86,8.62-72.66,15.28-95.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M211.72,194V296.86a68.25,68.25,0,0,1-68.24,68.26v-.05c19.46-6.93,37.24-25.88,50.37-60.84C201.59,283.65,211.72,225.4,211.72,194Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M158.76,78.34c-6.66,22.7-14.09,66.5-15.29,95.35V78.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M283,365.06l-.17.06"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/logo.7fb277a1.svg";
export { ForwardRef as ReactComponent };